import React from 'react'
import SinglePageRenderer from '../SinglePageRenderer'

const ImprintPage = () => (
	<SinglePageRenderer paddingTop={70} title="SN - Imprint" pageId="imprint" />
)

export default ImprintPage
